<template>
  <v-app>
    <v-app-bar dark app v-if="isLoggedIn" style="z-index: 999999;">
      <v-toolbar-title><AppLogo/></v-toolbar-title>
      <v-app-bar-nav-icon @click.stop="toggleDrawer">
        <v-icon>{{ drawerIcon }}</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <template>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              class="text mr-2"
              small
              color="rgba(255, 255, 255, 0.15)"
            >
              <img
                :src="getFlagImageSrc(currentLanguage)"
                alt="flag"
                height="20"
                style="margin-right: 6px"
              />
              {{ resolveLanguageLabel(currentLanguage) }}
            </v-btn>
          </template>

          <v-list class="lang_option">
            <v-list-item
              v-for="language in languageOptions"
              :key="language.code"
              @click="changeLanguage(language.code)"
              style="padding: 0 10px"
            >
              <v-list-item-title class="d-flex align-center">
                <img
                  :src="getFlagImageSrc(language.code)"
                  alt="flag"
                  height="20"
                  style="margin-right: 6px"
                />
                <span class="lang_name">{{ language.label || resolveLanguageLabel(language.code) }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <!-- <template>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" elevation="0" class="text mr-2" small color="rgba(255, 255, 255, 0.15)" >
              {{ $store.getters.t('언어/LANG/语言') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="language in ['KOR', 'ENG', 'CHN', 'JPN']" 
              :key="language" 
              @click="changeLanguage(language)">
              <v-list-item-title>
                <span>{{ $store.getters.t(language) }}</span>
                
                <img :src="getFlagImageSrc(language)" alt="flag" height="24" />
              </v-list-item-title>
            </v-list-item>
          </v-list>  
        </v-menu>
      </template> -->


      <v-btn small class="mr-2" color="#006CEA" @click="uploadDialog = true">
        <v-icon small>mdi-tray-arrow-up</v-icon>
        <span class="ml-2 d-none d-sm-inline-flex">{{ $store.getters.t('업로드') }}</span>
      </v-btn>

      <!-- <router-link to="/vod-manual" target="_blank">
        <v-btn class="mr-2" small color="rgba(255, 255, 255, 0.15)">
          <v-icon small>mdi-file-document-outline</v-icon>
          <span class="ml-2 d-none d-sm-inline-flex">{{ $store.getters.t('매뉴얼') }}</span>
        </v-btn>
      </router-link> -->
      <a :href="moveToManual" target="_blank" rel="noopener">
        <v-btn class="mr-2" small color="rgba(255, 255, 255, 0.15)">
          <v-icon small>mdi-file-document-outline</v-icon>
          <span class="ml-2 d-none d-sm-inline-flex">{{ $store.getters.t('매뉴얼') }}</span>
        </v-btn>
      </a>


      <AccountInfo/>
    </v-app-bar>

    <Upload v-if="isLoggedIn" :dialog.sync="uploadDialog" :multiple="true" @filesUploaded="processUpload($event)" />

    <TheDrawer v-if="isLoggedIn" :drawer="drawer" @update:drawer="drawer = $event"/>

    <v-main style="height: 100%;">
      <v-container fluid style="padding: 0px;height: 100%;">
        <router-view />
        <snackbar :message="snackbarMessage" :visible="snackbarVisible" :error="snackbarError" />
      </v-container>
    </v-main>


    <!-- <TheDrawer :drawer="drawer" @update:drawer="drawer = $event"/>

    <v-app-bar dark app v-if="isLoggedIn" style="z-index: 999999;">
      <AppLogo />
      <v-app-bar-nav-icon @click.stop="toggleDrawer" v-if="isLoggedIn">
        <v-icon>{{ drawerIcon }}</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <template>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" elevation="0" class="text mr-2" small color="rgba(255, 255, 255, 0.15)" >
              {{ $store.getters.t('언어/LANG/语言') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="language in ['KOR', 'ENG', 'CHN', 'JPN']" 
                        :key="language" 
                        @click="changeLanguage(language)">
              <v-list-item-title>
                {{ $store.getters.t(language) }}
                <img :src="getFlagImageSrc(language)" alt="flag" height="24">
              </v-list-item-title>
            </v-list-item>
          </v-list>  
        </v-menu>
      </template>

      <v-btn small class="mr-2" color="#006CEA" v-if="isLoggedIn" @click="uploadDialog = true">
        <v-icon small>mdi-tray-arrow-up</v-icon>
        <span class="ml-2 d-none d-sm-inline-flex">{{ $store.getters.t('업로드') }}</span>
      </v-btn>

      <router-link to="/vod-manual" target="_blank">
        <v-btn class="mr-2" small color="rgba(255, 255, 255, 0.15)" v-if="isLoggedIn">
          <v-icon small>mdi-file-document-outline</v-icon>
          <span class="ml-2 d-none d-sm-inline-flex">{{ $store.getters.t('매뉴얼') }}</span>
        </v-btn>
      </router-link>

      <AccountInfo v-if="isLoggedIn"/>

    </v-app-bar>

    <Upload v-if="isLoggedIn" :dialog.sync="uploadDialog" :multiple="true" @filesUploaded="processUpload($event)" />

    <v-main style="height: 100%;">
      <v-container fluid style="padding: 0px;height: 100%;">
        <router-view />
        <snackbar :message="snackbarMessage" :visible="snackbarVisible" :error="snackbarError" />
      </v-container>
    </v-main> -->

  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppLogo from '@/components/app/AppLogo.vue';
import Logout from '@/components/user/LogoutForm.vue';
import TheDrawer from './TheDrawer.vue';
import Upload from '@/components/upload/UploadDialog.vue';
import Snackbar from '@/components/ui/snackbar/UploadSnackbar.vue';
import AccountInfo from '@/components/user/AccountInfo.vue';

const FALLBACK_LANGUAGE_OPTIONS = [
  { code: 'KOR', label: '한국어' },
  { code: 'ENG', label: 'English' },
  { code: 'CHN', label: '中文' },
  { code: 'JPN', label: '日本語' },
];

export default {
  name: 'TheMain',
  components: {
    AppLogo,
    Logout,
    TheDrawer,
    Upload,
    // MyModal,
    Snackbar,
    AccountInfo
  },
  data() {
    return {
      drawer: true,
      miniState: false,
      selectedItem: null,
      mini: false,
      subMenuDrawer: false,
      groupListDrawer: false,
      uploadDialog: false,
      snackbarVisible: false,
      snackbarMessage: '',
      snackbarError: false
    };
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('user/adminCheck');
    }
  },
  computed: {
    ...mapGetters('test', ['isModalOpen']),
    ...mapGetters('upload', ['lastCompletedFileName']),
    languageOptions() {
      const options = this.$store.getters.availableLanguages;
      if (Array.isArray(options) && options.length) {
        return options;
      }
      return FALLBACK_LANGUAGE_OPTIONS;
    },
    currentLanguage() {
      return this.$store.getters.currentLanguage || 'KOR';
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn'];
    },
    drawerIcon() {
      return this.drawer ? 'mdi-chevron-left' : 'mdi-menu';
    },
    moveToManual(){
      const lang = this.$store.getters.currentLanguage;
      let temp;
      if(lang == 'KOR'){
        temp = 'kr';
      } else if(lang == 'ENG'){
        temp = 'en';
      } else if(lang == 'CHN'){
        temp = 'cn';
      } else if(lang == 'JPN'){
        temp = 'jp';
      }

      const versionNum = process.env.VUE_APP_VERSION ?? '1_0';

      const url = this.$store.getters.t('manual_url')  + '/' + versionNum + '/' + temp;
    
      // console.log("url => ", url);

      return url;
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    ...mapActions('test', ['toggleModal']),
    getFlagImageSrc(language) {
      const code = (language || 'kor').toString().toLowerCase();
      try {
        return require(`@/styles/assets/${code}.png`);
      } catch (error) {
        return require('@/styles/assets/kor.png');
      }
    },
    changeLanguage(lang) {
      this.$store.commit('setLanguage', lang);
    },
    resolveLanguageLabel(code) {
      if (!code) {
        return '';
      }
      const option = this.languageOptions.find(item => item.code === code);
      if (option && option.label) {
        return option.label;
      }
      const translated = this.$store.getters.t ? this.$store.getters.t(code) : code;
      return translated || code;
    }
  },
  watch: {
    lastCompletedFileName(newName, oldName) {
      if (newName !== oldName && newName) {
        this.snackbarVisible = true;
        // this.snackbarMessage = this.$store.getters.t('upload.success', { filename: newName });
        this.snackbarMessage = `${newName} ${ this.$store.getters.t('upload.success')}`;
        setTimeout(() => {
          this.snackbarVisible = false;
        }, 10000);
      }
    }
  },
  // mounted() {
  //   if (this.isLoggedIn) {
  //     this.$store.dispatch('naviList/list');
  //   }
  // },
  // watch: {
  //   isLoggedIn(newVal) {
  //     if (newVal) {
  //       this.$store.dispatch('naviList/list');
  //     }
  //   }
  // }
};
</script>

<style scoped>
header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 99999 !important;
}

.group_list_drawer {
  margin-left: 60px;
}

.sub_menu_drawer {
  margin-left: 60px;
}


.navigation_drawer {
  margin-top: 64px;
}

.mini-items .v-list-item-icon {
  min-width: 56px;
}

.v-list-item {
  align-items: center !important;
}

.mini-items .v-list-item {
  justify-content: center;
}

.flex-container {
  display: flex;
  width: 100%;
}

.mini-items {
  width: 50px;
  transition: width 0.3s ease;
}

.selected-item {
  background-color: #e0e0e0;
}

.v-btn-toggle {
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.v-btn-toggle .v-btn {
  opacity: 0.7;
  transition: opacity 0.3s;
}

.v-btn-toggle .v-btn--active {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.1);
}
.v-menu__content--fixed {
  top: 50px !important;
}
.lang_option {
  padding: 0 !important;
}
.lang_option .lang_name {
  font-size: 14px;
}
</style>
